import { Injectable, inject } from '@angular/core';

import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmDialog } from '@venecia/organisms';

export type ConfirmDialogType = 'success' | 'info' | 'warning' | 'danger';

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
    private readonly modal = inject(NgbModal);

    async open(opts: ConfirmDialogOptions = {}): Promise<boolean> {
        const modalRef = this.modal.open(ConfirmDialog, <NgbModalOptions>{
            backdrop: 'static',
            keyboard: true,
            centered: opts.centered ?? true,
            size: opts.size ?? 'sm',
        });

        const component = modalRef.componentInstance;

        component.setType(opts.type ?? 'info');
        component.setDialogMode(opts.dialogMode ?? false);
        component.setAutoCloseMillis(opts.autoCloseMillis ?? 5000);

        if (opts.title) {
            component.setTitle(opts.title);
        }

        if (opts.message) {
            component.setMessage(opts.message);
        }

        if (opts.details !== undefined) {
            component.setDetails(opts.details);
        }

        if (opts.confirmText) {
            component.setConfirmText(opts.confirmText);
        }

        if (opts.cancelText) {
            component.setCancelText(opts.cancelText);
        }

        return modalRef.result
            .then(() => true)
            .catch(() => false);
    }
}

export interface ConfirmDialogOptions {
    readonly title?: string;
    readonly message?: string;
    readonly details?: string | null;
    readonly confirmText?: string;
    readonly cancelText?: string;
    readonly size?: 'sm' | 'lg' | 'xl';
    readonly centered?: boolean;
    readonly dialogMode?: boolean;
    readonly type?: ConfirmDialogType;
    readonly autoCloseMillis?: number;
}
